import { Entity, Column, PrimaryGeneratedColumn, JoinColumn, Index, ManyToOne, OneToMany } from "typeorm";
import { User } from "./User";
import { OrganizationStatuses } from "../enums/";
import { OrgChangeRequest } from "./OrgChangeRequest";
import { ReportDownload } from "./ReportDownload";

@Entity()
export class Organization {
  @PrimaryGeneratedColumn() id: number;

  @Index()
  @Column("int")
  version: number;

  @Column("varchar") name: string;
  @Column("varchar") address1: string;
  @Column("varchar") address2: string;
  @Column("varchar") city: string;
  @Column("varchar") state: string;
  @Column("varchar") zip: string;
  @Column("varchar") town: string;
  @Column("varchar") county: string;
  @Column("varchar") postcode: string;
  @Column("varchar") landLine: string;
  @Column("varchar") email: string;
  @Column("varchar") licNoDistribution: string;
  @Column("int") licNumberOfUnits: number;
  @Column("tinyint", { nullable: true })
  licOneTimePayment: boolean;
  @Column("varchar") licDefinitions: string;
  @Column("varchar") licUseCases: string;
  @Column("varchar") organizationType: string;
  @Column("varchar", {
    default: () => "'" + OrganizationStatuses.PENDING_ACTIVATION + "'"
  })
  status: string;

  @Column("varchar") stripeCustomerId: string;
  @Column("varchar") stripePaymentMethodId: string;

  @Column("varchar", { length: 5, nullable: true })
  region: string;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @ManyToOne(() => User)
  @JoinColumn()
  updatedBy: User;

  @OneToMany(() => User, user => user.organization)
  users: User[];

  @OneToMany(() => ReportDownload, reportDownload => reportDownload.organization)
  reportDownloads: ReportDownload[];

  @OneToMany(() => OrgChangeRequest, orgChangeRequest => orgChangeRequest.organization)
  orgChangeRequests: OrgChangeRequest[];

  @Column("int", { nullable: true })
  deactivationRequestedById: number | null;

  @ManyToOne(() => User)
  @JoinColumn()
  deactivationRequestedBy: User | null;

  // https://github.com/typeorm/typeorm/issues/2178#issuecomment-527192646
  // creates a 'virtual' column so that getMany() will work in getAllCustomerAccounts
  @Column("int", { nullable: true, select: false })
  licenseRequestCount: number;

  @Column("datetime") deactivationRequestedAt: Date | null;

  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;
}
